
import {defineComponent} from 'vue';
import SelectOption from '@ohrm/oxd/core/components/Input/Select/SelectOption.vue';
import usei18n from '../../../../composables/usei18n';

export default defineComponent({
  name: 'oxd-select-dropdown',

  components: {
    'oxd-select-option': SelectOption,
  },

  props: {
    empty: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: null,
    },
  },

  setup() {
    return {
      ...usei18n(),
    };
  },

  computed: {
    placeholderText(): string {
      return (
        this.emptyText ?? this.t('general.no_records_found', 'No records found')
      );
    },
  },
});
